import { IUserState, UserActions } from "./user.interface";

const initialState: IUserState = {
  id: 0,
  firstname: "",
  lastname: "",
  email: "",
  userLoad: true,
  errorRequest: false,
  userDisconected: true,
  profile: {
    id: 0,
    name: "",
    type: {
      id: 0,
      name: ""
    }
  },
  permissions: [],
  current_date: "",
  isLogout:false
};
interface Action{type: UserActions, payload: {
  user: IUserState;
}}

export const userReducer = (state: IUserState = initialState, action: Action):IUserState => {
  switch (action.type) {
    case UserActions.LOAD_USER:
      return {...state, userLoad: true, errorRequest:false}
    case UserActions.SET_USER:
      return {...state, ...action.payload.user, errorRequest:false, userLoad: false, userDisconected: false}
    case UserActions.ERROR_REQUEST:
      return {...state, ...action.payload.user, userLoad: false, errorRequest: true}
    case UserActions.LOGOUT:
      return {...state, id: 0, userLoad: true, isLogout: true}
    case UserActions.USER_DISCONECTED:
      return {...initialState, userDisconected:true, userLoad: false, isLogout: false}
    case UserActions.SET_THEME:
      return {...state, ...action.payload.user}
    case UserActions.SET_LANGUAGE:
      return {...state, ...action.payload.user}
    default:
      return state;
  }
}